// src/components/Header.tsx
import React from 'react';
import { Event } from '../data/eurovisionData';

interface HeaderProps {
  event: Event;
}

export function Header({ event }: HeaderProps) {
  return (
    <div className="mb-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold">Eurovision Ranking Competition</h1>
          <p className="text-sm font-medium">Predict. Compete. Win.</p>
        </div>
        <div className="relative w-12 h-12">
          {/* Eurovision heart logo */}
          <img 
            src={`${process.env.PUBLIC_URL}/flags/CHx2.png`} 
            alt="Eurovisions 2025"
            className="w-full w-12 object-cover"
          />
        </div>
      </div>
      
      <p className="text-gray-500 text-sm mt-2">
        Predict {event.name}'s Top {event.maxRankings} for a chance to win exciting prizes!
      </p>
    </div>
  );
}